import apiClient from "@/services/ApiClient"

export function crudActions(serviceName) {
  return {
    name() {
      return serviceName
    },
    getListHeaders() {
      return apiClient.get(`/${serviceName}/headers`)
    },
    getListItems() {
      return apiClient.get(`/${serviceName}/items`)
    },
    getListItem(id) {
      return apiClient.get(`/${serviceName}/items/${id}`)
    },
    getItem(id) {
      return apiClient.get(`/${serviceName}/${id}`)
    },
    newItem() {
      return apiClient.get(`/${serviceName}/new`)
    },
    createItem(data) {
      return apiClient.post(`${serviceName}`, data)
    },
    updateItem(id, event) {
      return apiClient.put(`/${serviceName}/${id}`, event)
    },
    newCloneItem(id) {
      return apiClient.get(`/${serviceName}/clone/${id}`)
    },
    createCloneItem(id, data) {
      return apiClient.post(`/${serviceName}/clone/${id}`, data)
    },
    deleteItems(ids) {
      return apiClient.post(`/${serviceName}/delete`, { id: ids })
    },
    saveColumns(data) {
      return apiClient.post("/crud-configurations/save-columns", {
        name: serviceName,
        data: data,
      })
    },
  }
}
